import { createActionGroup, emptyProps,  props } from '@ngrx/store';

export const NavigationsActions = createActionGroup({
  source: 'Navigation',
  events: {
    'Redirect to ThankYou Page': props<{ appointmentUuid: string }>(),
    'Redirect to Payment Client': props<{ url: string }>(),
  }
});

export const NavigationUtilsActions = createActionGroup({
  source: 'Navigation Utils',
  events: {
    'Clear payment status URL': emptyProps()
  }
});
